import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/work_logs/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchHarvestTeams(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/work_logs/manage_harvest_team_work_log/${organization_id}/fetch_harvest_teams/${harvest_process_id}`
    );
  },

  fetchHarvestTeamWorkLog(
    organization_id,
    harvest_process_id,
    harvest_team_work_log_id
  ) {
    return RequesterV1.get(
      `organization/process/work_logs/manage_harvest_team_work_log/${organization_id}/fetch_harvest_team_work_log/${harvest_process_id}/${harvest_team_work_log_id}`
    );
  },

  create(organization_id, harvest_process_id, harvest_team_work_log) {
    return RequesterV1.post(
      `organization/process/work_logs/manage_harvest_team_work_log/${organization_id}/create/${harvest_process_id}`,
      { harvest_team_work_log }
    );
  },

  update(
    organization_id,
    harvest_process_id,
    harvest_team_work_log_id,
    harvest_team_work_log
  ) {
    return RequesterV1.post(
      `organization/process/work_logs/manage_harvest_team_work_log/${organization_id}/update/${harvest_process_id}/${harvest_team_work_log_id}`,
      { harvest_team_work_log }
    );
  },

  destroy(organization_id, harvest_process_id, harvest_team_work_log_id) {
    return RequesterV1.delete(
      `organization/process/work_logs/manage_harvest_team_work_log/${organization_id}/destroy/${harvest_process_id}/${harvest_team_work_log_id}`
    );
  },
};
